export default __webpack_public_path__ + "en-prothomalo-colored.png";